// @flow
import React from 'react';
import './SectionThumbnail.scss';

type Props = {
  thumbnail: string,
  title: string,
  description: string,
  onClick: () => void,
};

const SectionThumbnail = ({ thumbnail, title, onClick }: Props) => {
  return (
    <div className="SectionThumbnail" onClick={onClick}>
      <div className="thumbnail-wrapper">
        <img src={thumbnail} alt={title} />
      </div>
      <p className="section-title">{title}</p>
    </div>
  );
};

export default SectionThumbnail;



// WEBPACK FOOTER //
// ./src/components/trending/SectionThumbnail/SectionThumbnail.js